module.exports = __webpack_public_path__ + "img/statistic-subscriptions-all.aeeea7ec.svg";